import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Modal from '../Modal'
import ApiService from '../../data/services/ApiService'
import PaymentForm from '../../pages/pagos/PaymentForm'

const isPaidPlan = (plan) => {
    const planName = String(plan?.nombre || '').trim().toLowerCase()
    return Boolean(
        plan &&
        plan.status === true &&
        planName !== 'libre' &&
        planName !== 'trial' &&
        Number(plan.precio) > 0 &&
        Number(plan.timbres) > 0
    )
}

const BillingPaywallModal = ({ isOpen, onRequestClose, onActivated, empresa }) => {
    const [plans, setPlans] = useState([])
    const [currentPlan, setCurrentPlan] = useState(null)
    const [error, setError] = useState('')

    useEffect(() => {
        if (!isOpen) { return }

        setError('')
        ApiService.getPlans()
            .then(response => {
                const paidPlans = (response.data.plans || []).filter(isPaidPlan)
                const rawPlan = empresa?.plan
                const selectedPlanId = typeof rawPlan === 'object'
                    ? rawPlan?._id
                    : (empresa?.intendedPlan || rawPlan)
                const preferred = paidPlans.find(plan => plan._id === selectedPlanId)
                const fallback = paidPlans.find(plan => plan.nombre === 'arranque') || paidPlans[0] || null

                setPlans(paidPlans)
                setCurrentPlan(preferred || fallback)
                if (!preferred && !fallback) {
                    setError('No hay planes disponibles para activar tu cuenta.')
                }
            })
            .catch(() => setError('No pudimos cargar los planes. Intenta de nuevo.'))

        if (window.analytics) {
            window.analytics.track('Paywall abierto', {
                source: 'first_invoice',
                selectedPlanId: empresa?.intendedPlan || empresa?.plan || null
            })
        }
    }, [isOpen, empresa])

    const handleSuccess = () => {
        if (window.analytics) {
            window.analytics.track('Paywall pago completado', { source: 'first_invoice' })
        }
        onActivated()
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Activar plan"
            title="Activa tu plan para timbrar"
            styles={{ content: { width: 'min(720px, 94vw)', maxHeight: '92vh', overflowY: 'auto' } }}
            body={error
                ? <p className="text-danger">{error}</p>
                : currentPlan
                    ? (
                        <>
                            <p className="text-muted">
                                Tu factura está lista. Elige un plan y completa el pago para timbrarla.
                            </p>
                            <PaymentForm
                                currentPlan={currentPlan}
                                plans={plans}
                                onSuccess={handleSuccess}
                            />
                        </>
                    )
                    : <p className="text-muted">Cargando planes...</p>}
        />
    )
}

const mapStateToProps = (state) => ({ empresa: state.Auth.profile?.empresa || {} })

export default connect(mapStateToProps)(BillingPaywallModal)
